// extracted by mini-css-extract-plugin
export default {"container":"tN-z","title":"uN-z","link":"vN-z"};